import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { baseUrl, Fetch } from "../../../shared/Fetch";
import { JVDate } from "../../../shared/JVDate";
import { IUsersDropdown, ICompanyMastDropdown, IBranchMastDropdown, ITeamsDropdown, IIndustryMastDropdown } from "../../../models/IDropdown";
import { JVDropdown } from "../../../shared/JVDropdown";
import { useEffect, useState } from "react";
import { ILogin } from "../../../models/Login";
import { JVCheckbox } from "../../../shared/JVCheckbox";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import { format } from "date-fns";

export interface IRecEffFilter {
    fromDate?: Date | null | string,
    toDate?: Date | null | string,
    company?: number | null,
    branch?: number[] | null,
    team?: number | null,
    recruiter?: number | null,
    user_Status?: boolean | null,
    frequency?: number | null,
    exclude_From_Report?: boolean | null,
    branch_Sales?: number[] | null,
    agreegate_Report?: boolean | null,
    industry_Id?: number | null
}

export const EmptyRecEffFilter: IRecEffFilter = {
    fromDate: new Date,
    toDate: new Date,
    company: null,
    branch: null,
    team: null,
    recruiter: null,
    user_Status: true,
    frequency: null,
    exclude_From_Report: null,
    branch_Sales: null,
    agreegate_Report: null,
    industry_Id: null

}

interface Iprops {
    setSalEffFilter: (salEffFilter: IRecEffFilter) => void;
    onSearch: () => void;
    toast: any;
}

export const Filter = (props: Iprops) => {
    const [recruiters, setRecruiters] = useState<Array<IUsersDropdown>>();
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [team, setTeam] = useState<Array<ITeamsDropdown>>();
    const [excel, setExcel] = useState<{ show: boolean, num: number | null }>({ show: false, num: null });
    const [excelLoading, setExcelLoading] = useState<boolean>(false);

    const [selectedBranch, setSelectedBranch] = useState<Array<number>>([]);
    // const [selectedSBranch, setSelectedSBranch] = useState<Array<number>>([]);
    const [selectedRecruiter, setSelectedRecruiter] = useState<number | null>(null);
    const [selectedTeam, setSelectTeam] = useState<number | null>(null);

    const [industry, setIndustry] = useState<Array<IIndustryMastDropdown>>();


    const { control, handleSubmit, reset, watch } = useForm<IRecEffFilter>({
        defaultValues: EmptyRecEffFilter,
        shouldFocusError: false
    });

    const downloadExcel = async (exceltype: number) => {
        setExcelLoading(p => p = true);
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const filter = { ...control._formValues };
            if (selectedBranch.length > 0) filter.branch = selectedBranch;
            if (selectedTeam) filter.team = selectedTeam;
            if (selectedRecruiter) filter.recruiter = selectedRecruiter;
            delete filter.frequency;

            filter.fromDate = filter.fromDate ? format(new Date(filter.fromDate), 'yyyy-MM-dd') : null;
            filter.toDate = filter.toDate ? format(new Date(filter.toDate), 'yyyy-MM-dd') : null;

            const response = await fetch(`${baseUrl}${"Report_Recruiter_Efficiency/getexcel"}?` + `filter=` + encodeURIComponent(JSON.stringify(filter)) + `&exceltype=${exceltype}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `RecruiterEfficiencyReport.xlsx`;
                a.href = href;
                a.click();
                a.href = '';
                setExcelLoading(p => p = false);
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
                setExcelLoading(p => p = false);
            }
        } catch {
            setExcelLoading(p => p = false);
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    const recruiters_Status = [
        { label: "-- SELECT --", status: null },
        { label: 'Active', status: true },
        { label: 'Inactive', status: false },
    ]

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const loadRecruiters = async (branch: number[] | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (branch && branch.length > 0 && branch[0] != 0) {
            queryParameter = branch.map(b => `branch_ID=${b}`).join("&");

        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        } else if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        }

        const response = await Fetch("Dropdown/SalesManagerListBranch", "GET", null, `user_Type=recruiter&${queryParameter}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setRecruiters(data);
        }
    }



    const loadBranches = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        let endPoint = loginObj.id === 1346 ? "allBranches" : "reqBranchList";

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    }
    const loadCompanies = async () => {
        let endPoint = loginObj.id === 1346 ? "company" : "reqCompanyList";

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    }

    const loadTeam = async (branch: number[] | null | undefined, company: number | null | undefined) => {
        let queryParameter = null;
        if (branch && branch.length > 0 && branch[0] != 0) {
            // queryParameter = `branch_ID=${branch}`;
            queryParameter = branch.map(b => `branch_ID=${b}`).join("&");

        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterTeamsBranchList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<ITeamsDropdown> = await response.json();
            const emptyData = {
                team_ID: 0,
                team_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setTeam(data);
        }
    }

    const loadIndsutry = async () => {
        const response = await Fetch("Dropdown/industries", "GET", null, null, null);
        if (response) {
            let data: Array<IIndustryMastDropdown> = await response.json();
            data.unshift({
                industry_Id: 0,
                industry_Name: "--SELECT--",
            });
            setIndustry(data);
        }
    }


    useEffect(() => {
        loadRecruiters([], 0, 0);
        loadCompanies();
        loadIndsutry();
        loadBranches();
        loadTeam([], 0);
    }, []);

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "company") {
                if (value.company != 0) {
                    loadBranches(value.company);
                    loadRecruiters([], value.company, 0);
                    loadTeam([], value.company);
                } else {
                    loadBranches();
                    loadTeam([], 0);
                    if (control._formValues.branch != 0) {
                        loadTeam(control._formValues.branch, 0);
                    } else if (control._formValues.branch == 0) {
                        loadTeam([], 0);
                    }

                    if (control._formValues.branch != 0 && control._formValues.team != 0) {
                        loadRecruiters([], 0, control._formValues.team);
                    } else if (control._formValues.branch == 0 && control._formValues.team != 0) {
                        loadRecruiters([], 0, control._formValues.team);
                    } else if (control._formValues.branch != 0 && control._formValues.team == 0) {
                        loadRecruiters(control._formValues.branch, 0, 0);
                    } else if (control._formValues.branch == 0 && control._formValues.team == 0) {
                        loadRecruiters([], 0, 0);
                    }
                }
            }

            if (name === "branch") {
                if (selectedBranch.length > 0) {
                    //   loadRecruiters(value.branch[0], 0, 0);
                    // loadTeam(value.branch[0], 0);
                } else {
                    if (control._formValues.company != 0) {
                        loadTeam([], control._formValues.company);
                    } else if (control._formValues.company == 0) {
                        loadTeam([], 0);
                    }

                    if (control._formValues.company != 0 && control._formValues.team != 0) {
                        loadRecruiters([], 0, control._formValues.team);
                    } else if (control._formValues.company == 0 && control._formValues.team != 0) {
                        loadRecruiters([], 0, control._formValues.team);
                    } else if (control._formValues.company != 0 && control._formValues.team == 0) {
                        loadRecruiters([], control._formValues.company, 0);
                    } else if (control._formValues.company == 0 && control._formValues.team == 0) {
                        loadRecruiters([], 0, 0);
                    }
                }
            }

            if (name === "team") {
                if (value.team && value.team != 0) {
                    loadRecruiters([], 0, value.team);
                } else {
                    if (control._formValues.company != 0 && control._formValues.branch != 0) {
                        loadRecruiters(control._formValues.branch, 0, 0);
                    } else if (control._formValues.company == 0 && control._formValues.branch != 0) {
                        loadRecruiters(control._formValues.branch, 0, 0);
                    } else if (control._formValues.company != 0 && control._formValues.branch == 0) {
                        loadRecruiters([], control._formValues.company, 0);
                    } else if (control._formValues.company == 0 && control._formValues.branch == 0) {
                        loadRecruiters([], 0, 0);
                    }
                }
            }

            if (name === "frequency") {
                if (value.frequency) {
                    setExcel(prev => ({ ...prev, show: true, num: value?.frequency || 0 }));
                } else {
                    setExcel(prev => ({ ...prev, show: false, num: null }));
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);




    const searchToDB = async (body: IRecEffFilter) => {
        let filterData: any = body;
        let emptyFilter: any = EmptyRecEffFilter;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
        }
        if (body.industry_Id === 0) {
            body.industry_Id = null;
        }

        body = filterData;
        props.setSalEffFilter(body);
    }

    function onSubmit(data: IRecEffFilter) {
        if (selectedBranch.length > 0) data.branch = selectedBranch;
        if (selectedTeam) data.team = selectedTeam;
        if (selectedRecruiter) data.recruiter = selectedRecruiter;
        delete data.frequency;
        searchToDB(data);
        props.onSearch();
    }

    useEffect(() => {
        if (selectedBranch.length > 0) {
            loadTeam(selectedBranch, 0); // Assuming loadTeam takes a single branch
            loadRecruiters(selectedBranch, 0, 0); // Pass the entire array
        }
    }, [selectedBranch]);


    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

            <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="fromDate" />
            <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="toDate" />
            <JVDropdown column={6} label="Company" control={control} name="company" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
            <div className="field col-2 md:col-2">
                <p>Recruiter Branch</p>
                <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={selectedBranch} onChange={(e) => setSelectedBranch(e.value)} options={branches} optionValue="branch_ID" optionLabel="branchName" display="chip" filter placeholder="Select Branches" />
            </div>
            {/* <div className="field col-2 md:col-2">
                <p>Sales Branch</p>
                <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={selectedSBranch} onChange={(e) => setSelectedSBranch(e.value)} options={branches} optionValue="branch_ID" optionLabel="branchName" display="chip" filter placeholder="Select Branches" />
            </div> */}
            <div className="field col-2 md:col-2">
                <p>Team</p>
                <Dropdown value={selectedTeam} style={{ height: "37px", marginTop: "-10px" }} onChange={(e) => { setSelectTeam(e.value); }} options={team} optionLabel="team_Name" placeholder="Select Team" optionValue="team_ID" filter />
            </div>
            <div className="field col-2 md:col-2">
                <p>Recruiter</p>
                <Dropdown value={selectedRecruiter} style={{ height: "37px", marginTop: "-10px" }} onChange={(e) => { setSelectedRecruiter(e.value); }} options={recruiters} optionLabel="user_Name" placeholder="Select Recruiter" optionValue="login_ID" filter />
            </div>
            <JVDropdown column={6} label="Recruiters Status" control={control} name="user_Status" options={recruiters_Status} optionLabel="label" optionValue="status" placeholder="Select User Status" />
            <JVDropdown column={6} required label="Industry Type" control={control} name="industry_Id" options={industry} optionLabel="industry_Name" optionValue="industry_Id" placeholder="Select Industry Type" />
            {(_roles.includes(1) || _roles.includes(20) || _roles.includes(26) || _roles.includes(40)) && <JVDropdown column={6} label="Frequency" control={control} name="frequency" options={[{ label: "--SELECT--", value: 0 }, { label: "Daily", value: 4 }, { label: "Weekly", value: 1 }, { label: "Monthly", value: 2 }, { label: "Quarterly", value: 3 }]} optionLabel="label" optionValue="value" placeholder="Select Type Of Excel" />}
            <div className="field col-12 md:col-6">
                <p style={{ color: 'white' }}>.</p>
                <JVCheckbox column={4} label="Show Excluded User" control={control} name="exclude_From_Report" />

            </div>
            <JVCheckbox column={4} label="Combined Report" control={control} name="agreegate_Report" />

            <div style={{ margin: '10px 0', width: '100%' }}></div>

            <div className="col-12 md:col-12" style={{ display: "flex", gap: "10px", marginTop: "10px", flexWrap: "nowrap" }}>
                <Button className="field" label="SEARCH" type="submit" style={{ height: "30px" }} />
                {excel.show && (
                    <Button className="field" loading={excelLoading} disabled={excelLoading} style={{ backgroundColor: "#9c27b0", height: "30px" }} label="GET EXCEL" onClick={() => { downloadExcel(excel.num || 0); }} />)}
                <Button className="field p-button-outlined" label="CLEAR" style={{ height: "30px" }} onClick={() => { reset(EmptyRecEffFilter); setExcel({ show: false, num: null }); setSelectedBranch([]); setSelectTeam(0); setSelectedRecruiter(null) }} type="button" />
            </div>
        </form>
    );
}
